import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { api, tokenStore } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);       // null = unknown, false = logged out
  const [loading, setLoading] = useState(true);

  // Try to restore session from stored token on first load
  useEffect(() => {
    const token = tokenStore.get();
    if (!token) { setUser(false); setLoading(false); return; }
    api.me()
      .then(setUser)
      .catch(() => { tokenStore.clear(); setUser(false); })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (username, password) => {
    const data = await api.login({ username, password });
    tokenStore.set(data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    tokenStore.clear();
    setUser(false);
  }, []);

  // Check if current user can access a given page key
  const can = useCallback((key) => {
    if (!user) return false;
    if (user.isAdmin) return true;
    return Array.isArray(user.permissions) && user.permissions.includes(key);
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, can }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
